import Validator from 'validatorjs'
import formatErrors from './formatErrors'

const rules = {
  name: 'required|regex:/^[- _a-zA-Z0-9.\']*$/',
  name_fa: 'required|regex:/^[^a-zA-Z]*$/',
  date: 'required|date'
}

export default function validateOwnerBox (values) {
  const validator = new Validator(values, rules, {
    required: 'این فیلد الزامی است',
    date: 'فرمت تاریخ صحیح نمی‌باشد',
    regex: 'فرمت این فیلد صحیح نمی‌باشد'
  })
  validator.passes()
  return formatErrors(validator.errors.all())
}



// WEBPACK FOOTER //
// ./src/utils/validateOwnerBox.js